import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Flex, Input, TextInput, TFChip, TFText } from '@tf/ui';
import { Controller, useFormContext } from 'react-hook-form';

import { TooltipIcon } from '../TooltipIcon';
import type { DefaultInputProps } from '../types';

const errorStyle = { borderColor: '#DC2626' };

export default function CheckboxInput({ name, label, isReadOnly, className, isRequired, tooltip }: DefaultInputProps) {
	const { control, getValues, setValue } = useFormContext();
	const { _ } = useLingui();

	return (
		<Controller
			control={control}
			name={name}
			render={({ field: { onChange, value }, fieldState: { error } }) => {
				return (
					<Input.Wrapper
						labelProps={{ style: { display: 'flex' } }}
						className={className}
						label={
							<Flex align={'center'}>
								<TFText fw="500">{label}</TFText>
								<TooltipIcon style={{ margin: '0 2px 0 4px' }} tooltip={tooltip} />
							</Flex>
						}
						error={Boolean(error)}
						required={isRequired}
					>
						{!isReadOnly ? (
							<Flex gap="8px">
								<TFChip
									id={`${name}-yes`}
									label={_(msg({ id: 'fb.checkboxInput.toggle.yes', message: 'Yes' }))}
									type="radio"
									style={error ? errorStyle : undefined}
									isActive={value === true}
									onClick={() => onChange(true)}
								/>
								<TFChip
									id={`${name}-no`}
									label={_(msg({ id: 'fb.checkboxInput.toggle.no', message: 'No' }))}
									type="radio"
									style={error ? errorStyle : undefined}
									isActive={value === false}
									onClick={() => onChange(false)}
								/>
							</Flex>
						) : (
							<TextInput
								value={
									value
										? _(msg({ id: 'fb.checkboxInput.toggle.yes', message: 'Yes' }))
										: _(msg({ id: 'fb.checkboxInput.toggle.no', message: 'No' }))
								}
								data-readonly="true"
								readOnly
							/>
						)}
					</Input.Wrapper>
				);
			}}
		/>
	);
}
